export default __webpack_public_path__ + "01c44507864fefb1b83f77053ac71bcf.png";